
import React, { lazy, Suspense} from "react";

import DefaultLoader from "../../utilities/loaders/DefaultLoader";
const AllRequestsContent = lazy(() => import('./AllRequestsContent'));



const AllRequests = () => {

    return (  
        <Suspense fallback={<DefaultLoader />}>
            <AllRequestsContent  />
        </Suspense>
    );
}

export default AllRequests;
